// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style__wrapper__9HRjY","title":"style__title__yLWMC","description":"style__description__LFDwT","component":"style__component__CYZk-"};